import { render, staticRenderFns } from "./XAddItemButton.vue?vue&type=template&id=43076b53"
import script from "./XAddItemButton.vue?vue&type=script&lang=js"
export * from "./XAddItemButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports